// 比较两个数组是否相等
import { isEqual } from 'lodash'

export function arraysAreEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false
  const clonedArr2 = [...arr2]
  // 遍历 arr1，逐个匹配 arr2 中的元素
  for (const item1 of arr1) {
    const index = clonedArr2.findIndex(item2 => isEqual(item1, item2))
    if (index === -1) return false
    clonedArr2.splice(index, 1) // 移除已匹配项
  }
  return true
}

export function formatStr(dateType) {
  const formatItem = {
    'year-month': 'YYYY-MM',
    date: 'YYYY-MM-DD',
    datetime: 'YYYY-MM-DD HH:mm:ss',
  }
  return formatItem[dateType] || 'YYYY-MM-DD HH:mm:ss'
}
